
import VideoAdd from "../../../assets/outline/VideoAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoAddIcon({ className, dataTestid = "VideoAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
